// frontend/src/context/DarkMode/index.js
// Provider fino: paletas e buildTheme moram em src/themes (Temas 2.0).
import React, { createContext, useState, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { buildTheme, isValidTheme, THEME_OPTIONS, KR } from "../../themes";

export { THEME_OPTIONS, KR };

const ThemeContext = createContext();

const readPersistedTheme = () => {
  try {
    const saved = localStorage.getItem("theme");
    if (saved && isValidTheme(saved)) return saved;
    if (localStorage.getItem("darkMode") === "true") return "dark";
  } catch {}
  return "light";
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(readPersistedTheme);

  const setTheme = (id) => {
    if (!isValidTheme(id)) return;
    try { localStorage.setItem("theme", id); } catch {}
    setCurrentTheme(id);
  };

  const muiTheme = useMemo(() => buildTheme(currentTheme), [currentTheme]);
  const darkMode = muiTheme.palette.mode === "dark";
  const toggleTheme = () => setTheme(darkMode ? "light" : "dark");

  const contextValue = useMemo(
    () => ({ theme: currentTheme, setTheme, darkMode, toggleTheme, KR }),
    [currentTheme, darkMode]
  );

  return (
    <ThemeContext.Provider value={contextValue}>
      <MUIThemeProvider theme={muiTheme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = { children: PropTypes.node.isRequired };
export const useThemeContext = () => useContext(ThemeContext);
